import fetch from "../config/http"
import {portalBasicApi} from "../config/configApi"

/**
 * @param {data } 数据请求的参数
 */

 /**
  * @param登录 
  */

export const Login = (data) => fetch(portalBasicApi + "/Access/Login", data, 'POST');
export const GetVerifyCode = () => fetch(portalBasicApi + "/Access/GetVerifyCode");
export const LoginOut = () => fetch(portalBasicApi + "/OnlineData/LoginOut");

/**获取授权状态 */
export const CheckLicenseState = () => fetch(portalBasicApi + "/License/CheckLicenseState");

//登陆之前检测
export const CheckToken = params => fetch(portalBasicApi + "/Access/CheckToken", params, 'POST');

export const ChangePassword = params => fetch(portalBasicApi + "/AccessAction/ChangePassword", params, "POST");
export const ChangePwdByEmail = params => fetch(portalBasicApi + "/Access/ChangePwdByEmail", params, 'POST');

export const WindowsLogin = params => fetch(portalBasicApi + "/Access/WindowsLogin", params, 'POST');